import { NodeEliot, Topology } from '~/interfaces/eliot.interface';

export class Plant {
    id = '';
    ownerId = '';
    ownerEmail = '';
    name = '';
    type = '';
    areGatewaysShown?: boolean;
    status?: string;
    country?: string;
    zipCode?: string;
    address?: string;
    allowedUsers?: Array <{ id: string, email: string }>;
    invitedUsers?: Array<{ id: string, email: string }>;
    topology?: Topology;
    ipAddress?: string;

    nodes: NodeEliot [] = [] as NodeEliot [];

    constructor(data: Plant) {
        this.loadData(data);
    }

    loadData(data: Plant) {
        Object.assign(this, data);
        this.loadNodesTopology(data);
    }

    loadNodesTopology(data: Plant) {
        // Create first level with the name of this plants
        this.addNode(this.nodes, this);
        if (data.topology) {
            this.recursiveBuildNodesTopology(this.nodes[0].children, data.topology);
        }
    }

    /**
     * Recursives function to load nodes formated for v-treeview component
     * In plant we could have : ambiants, floor, spaces, zones, modules (recursively)
     * @param nodes that we want fill
     * @param data level of data to add in nodes
     */
    recursiveBuildNodesTopology(nodes: NodeEliot [], data: Topology) {
        let children;

        if (data.modules && data.modules.length !== 0) {
            data.modules.forEach( (module) => {
                children = this.addNode(nodes, {
                    id: module.id,
                    name: `Module: ${module.name || module.id} - [${module.device}] ${module.deviceType}`,
                });
            });
        }

        if (data.zones && data.zones.length !== 0) {
            data.zones.forEach( (zone) => {
                children = this.addNode(nodes, {
                    id: zone.id,
                    name: `Zone: ${zone.name}`,
                });
                this.recursiveBuildNodesTopology(children, zone);
            });
        }

        if (data.ambients && data.ambients.length !== 0) {
            data.ambients.forEach( (ambient) => {
                children = this.addNode(nodes, {
                    id: ambient.id,
                    name: `Ambient: ${ambient.name} - [${ambient.type}]`,
                });
                this.recursiveBuildNodesTopology(children, ambient);
            });
        }

        if (data.floors && data.floors.length !== 0) {
            data.floors.forEach( (floor) => {
                children = this.addNode(nodes, {
                    id: floor.id,
                    name: `Floor: ${floor.name}`,
                });
                this.recursiveBuildNodesTopology(children, floor);
            });
        }

        if (data.spaces && data.spaces.length !== 0) {
            data.spaces.forEach( (space) => {
                children = this.addNode(nodes, {
                    id: space.id,
                    name: `Space: ${space.name} - [${space.type}]`,
                });
                this.recursiveBuildNodesTopology(children, space);
            });
        }
    }

    /**
     * Add node according v-treeview component format
     * Format : id, name, children
     * @param nodes nodes to fill
     * @param data data of new node to create
     */
    addNode(nodes: NodeEliot[], data: Topology) {
        // Add new node
        nodes.push({
            id: data.id,
            name: data.name,
            children: [],
        });

        // Return last node for recursivity
        return nodes[nodes.length - 1].children;
    }
}
